import React from 'react';
import { Footer } from '../Common/Footer';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import Request from '../../Models/Request';
import { SideBar } from '../Common/SideBar';
import ProductsUpload from '../../Models/ProductsUpload';
import { Header } from '../Common';
import Pagination from "react-js-pagination";
class RequestBulletin extends React.Component {
    constructor(props) {
        super(props);
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state = {
            _id: false,
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            total: [],
            categories: [],
            subCategories: [],
            category: '',
            sub_cat: '',
            user: '',
            request: [],
            product_name: '',
            category: '',
        };
        this.state.user = logged_user.id;
        this.getCategories();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillMount() {
        Request.getAllpending(1, this.state.user).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }
    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handlePageChange(pageNumber) {
        Request.getAllpending(pageNumber, this.state.user).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload, total: res.data.total, activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }

    pagination() {
        if (this.state.request < 10) {
            return (
                <div></div>
            )
        } else {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-6 ml-5">
                        <Pagination
                            hideNavigation
                            activePage={this.state.activePage}
                            itemsCountPerPage={this.state.itemsCountPerPage}
                            totalItemsCount={this.state.total}
                            pageRangeDisplayed={this.state.pageRangeDisplayed}
                            onChange={this.handlePageChange.bind(this)}
                        />
                    </div>
                    <div className="col-md-2"></div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <SideBar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="">
                                    <div className=" input_name big_font guide_text row" style={{ padding: "2%", width: '100%', border: "none" }}>
                                        <div className="col-md-6">
                                            <span style={{ fontSize: "20px" }}><b>リクエストボード</b></span>
                                        </div>
                                        <Link to={'/request-home'} className="col-md-6" style={{ textAlign: "left" }}>
                                            <button style={{ borderRadius: "4px", padding: "2%", fontSize: "15px", color: "green", backgroundColor: "white" }}>戻る</button>
                                        </Link>
                                    </div>
                                    <div className="" style={{ minHeight: "180px" }}>
                                        <div className="card">
                                            <div className="row pages_contents px-3">
                                                {this.state.request.map((group, index) =>
                                                    <div className="" style={{ width: "100%" }} key={index}>
                                                        <div className=" hover_div" style={{ padding: '0px' }}>
                                                            <div className="card-body" style={{ padding: '0.75rem' }}>
                                                                <div className="card-title" style={{ margin: '0px' }}>
                                                                    <Link to={{
                                                                        pathname: `/request-details/${group.id}`,
                                                                        state:
                                                                        {
                                                                            id: group.id,
                                                                            user: this.state.user
                                                                        }
                                                                    }}>
                                                                        <div className="blue_text" style={{ cursor: "pointer" }}>{group.title}</div>
                                                                    </Link>
                                                                </div>

                                                            </div>
                                                            <div className="">
                                                                <div style={{ minHeight: "86px" }}>
                                                                    <div className="col-md-12" >
                                                                        <span style={{ marginRight: '30px' }}>
                                                                            予算
                                                                            </span>
                                                                        <span>
                                                                            {group.budget_range} 円
                                                                            </span>
                                                                    </div>
                                                                    <div className="col-md-12" >
                                                                        <span style={{ marginRight: '30px' }}>
                                                                            募集期限
                                                                            </span>
                                                                        <span>
                                                                            {group.days} 日
                                                                            </span></div>
                                                                    <div className="col-md-12">
                                                                        <span style={{ marginRight: '46px' }}>
                                                                            提案数
                                                                            </span>
                                                                        <span>
                                                                            {group.number_of_proposals} 件
                                                                            </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.pagination()}
                    </div >
                    <Footer />
                </div >
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="">
                                            <div className=" input_name big_font guide_text row pt-0 pb-0" style={{ padding: "2%", width: '100%', border: "none" }}>
                                                <div className="col-md-6">
                                                    <span style={{ fontSize: "20px" }}><b><i>リクエストボード</i></b></span>
                                                </div>
                                                <Link to={'/request-home'} className="col-md-6" style={{ textAlign: "right" }}>
                                                    <button style={{ borderRadius: "4px", padding: "2%", fontSize: "15px", color: "green", backgroundColor: "white", height: '30px', width: '20%' }}>戻る</button>
                                                </Link>
                                            </div>
                                            <div className="mini_padding" style={{ height: "auto", paddingTop: '4px' }}>
                                                <div className="card">
                                                    <div className="row  px-3">
                                                        {this.state.request.map((group, index) =>
                                                            <div className="mini_padding inner-div" style={{ width: "100%" }} key={index}>
                                                                <div className="mini_padding hover_div">
                                                                    <div className="card-body">
                                                                        <div className="card-title">
                                                                            <Link to={{
                                                                                pathname: `/request-details/${group.id}`,
                                                                                state:
                                                                                {
                                                                                    id: group.id,
                                                                                    user: this.state.user
                                                                                }
                                                                            }}>
                                                                                <div className="blue_text" style={{ cursor: "pointer" }}>{group.title}</div>
                                                                            </Link>
                                                                        </div>
                                                                        {/* <div className="card-text">
                                                                            {group.content.substr(0, 20)}...
                                                                        </div> */}
                                                                    </div>
                                                                    <div className="">
                                                                        <div style={{ minHeight: "86px" }}>
                                                                            {/* <div className="row"> */}
                                                                            <div className="col-md-12" >
                                                                                <span style={{ marginRight: '30px' }}>
                                                                                    予算
                                                                            </span>
                                                                                <span>
                                                                                    {group.budget_range} 円
                                                                            </span>
                                                                            </div>
                                                                            <div className="col-md-12" >
                                                                                <span style={{ marginRight: '30px' }}>
                                                                                    募集期限
                                                                            </span>
                                                                                <span>
                                                                                    {group.days} 日
                                                                            </span></div>
                                                                            <div className="col-md-12">
                                                                                <span style={{ marginRight: '46px' }}>
                                                                                    提案数
                                                                            </span>
                                                                                <span>
                                                                                    {group.number_of_proposals} 件
                                                                            </span>
                                                                            </div>
                                                                        </div>
                                                                        {/* </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.pagination()}
                                {/* <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-6 ml-5">
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                        totalItemsCount={this.state.total}
                                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                                        onChange={this.handlePageChange.bind(this)}
                                    />
                                </div>
                                <div className="col-md-2"></div>
                            </div> */}
                            </div>
                        </div>
                    </div >
                    <Footer />
                </div >
            )
        }
    }
}
export { RequestBulletin }